<script>
import FundraiserCard from '@/components/fundraisers/public/fundraiser-card.vue'
import paginationMixin from '@/mixins/paginationMixin.js'
import FundraiserCategoriesRow from '@/components/fundraisers/fundraiser-categories-row.vue'
import fetchDataMixin from '@/mixins/fetchDataMixin.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import TwButton from '@/components/generic/tw-button.vue'
import { ChevronRightIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'TrendingFundraisers',
  components: { FundraiserCategoriesRow, FundraiserCard, TwButton, ChevronRightIcon },
  mixins: [fetchDataMixin, paginationMixin],
  data() {
    return {
      FundraiserCategorySelected:null
    }
  },
  computed: {
    fundraisers() {
      return useFundraiserPublicStore('trending-fundraisers').featured
    }
  },
  mounted() {
    this.fetchFeaturedFundraisers()
  },
  methods: {
    async fetchFeaturedFundraisers() {
      try {
        this.Loading = true
        await useFundraiserPublicStore('trending-fundraisers').fetchItems({
          featured: 1,
          per_page: 4,
          clear: true,
          ...(this.FundraiserCategorySelected && { fundraiser_category_id: this.FundraiserCategorySelected.id } ),
        })
        this.Loading = false
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    setFundraiserCategory(fundraiserCategory) {
      this.FundraiserCategorySelected = fundraiserCategory
      this.fetchFeaturedFundraisers()
    }
  }
}
</script>

<template>
  <div>
    <div class="flex w-full justify-between items-end mb-6 md:mb-10">
      <h2>
      Trending Campaigns
    </h2>
    <tw-button variant="link" class="gap-1 hidden md:flex">
      View More       
      <ChevronRightIcon class="size-4" aria-hidden="true" />
    </tw-button>
  </div>
       <!-- <fundraiser-categories-row featured :fundraiser-category-selected="FundraiserCategorySelected" class="mb-2" @fundraiser-category-selected="setFundraiserCategory" /> -->
    <TransitionGroup
      enter-active-class="duration-200 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="transform opacity-0" tag="div" name="fadeIn" class="grid xl:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-7"
    >
      <fundraiser-card v-for="fundraiser in fundraisers" :key="'card-' + fundraiser.id" :fundraiser="fundraiser" />
    </TransitionGroup>
    <tw-button variant="secondary" class="mt-6 flex gap-1 md:hidden w-full justify-center">
      View More Campaigns 
      <ChevronRightIcon class="size-4" aria-hidden="true" />    
    </tw-button>
  </div>
</template>

<style scoped>

</style>
